import React, { useEffect, useState } from 'react';
import {IdeasListing} from '../components/ideaslisting.js';
import { observer } from "mobx-react-lite";
import {Link} from "react-router-dom";
import { useMst } from '../models/root';

const APPLY_WHEN_YOU_NEED_MORE_OF_YOUR_IDEAS = 8;
const APPLY_WHEN_SENDING_TO_IDEA_COLLECTION = 6;
const IdeaCollection = observer(()=>{

    const {variables} = useMst();
    const [page,setPage] = useState(1)
    const handlescroll=(e)=>{
        let element=e.target;
        if(element.scrollHeight - element.scrollTop === (1.2*element.clientHeight)){
            setPage(page+1);
            variables._page(page);
            variables._e(0);
            variables._e(APPLY_WHEN_YOU_NEED_MORE_OF_YOUR_IDEAS);
        }
    };

    useEffect(()=>{
        variables._e(0);
        variables._e(APPLY_WHEN_SENDING_TO_IDEA_COLLECTION);
    },[])
    return (
        <div class="absolute h-full w-full">
            <div class="relative h-1/8">
            <div class="h-4 bg-pink-500"></div>
        
            <div class="flex my-4 justify-around flex-row">
                <Link to={{pathname:"/home"}}><div class="flex-initial rounded text-white bg-blue-700 w-20 text-center h-8">
                    <p class="pt-0.5">Back</p>
                    </div>
                </Link>
                <div class="flex-initial w-48 text-center h-8">
                    <p class="text-xl">Your Idea Collection</p>
                </div> 
            </div>
            </div>
            <div class="h-15 w-full">
                <div class="float-left h-2 w-1/12"></div>
                <p class="float-left w-10/12 text-sm">This is your private repository where you can collect the best ideas.</p>
            </div>
            <div class="h-7/8 w-full">
            <IdeasListing onScroll={handlescroll}/>
            </div>
        </div>
    );
})


export default IdeaCollection;